export enum ReferenceDataTypes {
  add_on_codes = 'add_on_codes',
  ages = 'ages',
  american_time_zones = 'american_time_zones',
  certification_types = 'certification_types',
  cpt_codes = 'cpt_codes',
  decline_reasons = 'decline_reasons',
  education_levels = 'education_levels',
  emergency_contact_relationships = 'emergency_contact_relationships',
  ethnicities = 'ethnicities',
  genders = 'genders',
  idc_codes = 'idc_codes',
  insurances = 'insurances',
  languages = 'languages',
  modalities = 'modalities',
  no_show_types = 'no_show_types',
  offered_services = 'offered_services',
  parent_specialties = 'parent_specialties',
  partner_certifications = 'partner_certifications',
  payment_methods = 'payment_methods',
  payout_methods = 'payout_methods',
  provider_member_statuses = 'provider_member_statuses',
  provider_rematch_reasons = 'provider_rematch_reasons',
  referral_sources = 'referral_sources',
  relationship_to_insured = 'relationship_to_insured',
  religions = 'religions',
  session_modalities = 'session_modalities',
  sexualities = 'sexualities',
  specialties = 'specialties',
  termination_reasons = 'termination_reasons',
  treatment_preferences = 'treatment_preferences',
  unmatch_reasons = 'unmatch_reasons',
  unsubscribed_contacts = 'unsubscribed_contacts',
  us_state_names = 'us_state_names',
  marital_statuses = 'marital_statuses'
}
